import { useEffect, useRef } from "react"
import { useLocation, useSearchParams } from "react-router-dom"

const openedOnboardingCreateKeys = new Set<string>()

export const useOnboardingCreatePopup = (openCreatePopup?: () => void) => {
  const location = useLocation()

  const [searchParams] = useSearchParams()

  const hasOpenedRef = useRef(false)

  useEffect(() => {
    const shouldOpen = searchParams.get("onboardingCreate") === "true"

    if (!shouldOpen) {
      hasOpenedRef.current = false

      return
    }

    if (hasOpenedRef.current || !openCreatePopup) {
      return
    }

    const openKey = `${location.key}:${location.pathname}:${location.search}`

    if (openedOnboardingCreateKeys.has(openKey)) {
      hasOpenedRef.current = true

      return
    }

    openedOnboardingCreateKeys.add(openKey)

    hasOpenedRef.current = true

    openCreatePopup()
  }, [location.key, location.pathname, location.search, openCreatePopup, searchParams])
}
